import requestFrame from "../../../shared/request-frame.js";

export default function ReplayGameHandler({ onReplayOver, onEnded, gameState }) {

    var localGameState = {
        paused: false,
        active: true,
        ended: false,
        replayTime: 0,
        previousUpdateTime: 0,
        speed: 1 // playback rate (the viewer's 0.5x / 1x / 2x / 4x)
    };

    function update() {
        if (localGameState.active) {
            var currentTime = Date.now();
            if (!localGameState.paused && !localGameState.ended) {
                var deltaTime = (currentTime - localGameState.previousUpdateTime) / 1000;

                localGameState.replayTime += deltaTime * localGameState.speed;

                if (localGameState.replayTime >= gameState.gameTime) {
                    // Reached the end: clamp and hold on the final frame. We stay in
                    // the replay (no onReplayOver) so the viewer can scrub back,
                    // restart, or leave deliberately via Exit. onEnded lets the view
                    // re-render so the button can flip to "Restart".
                    localGameState.replayTime = gameState.gameTime;
                    localGameState.ended = true;
                    if (onEnded) {
                        onEnded();
                    }
                }
            }
            localGameState.previousUpdateTime = currentTime;

            requestFrame(update);
        }
    }


    function start() {
        localGameState.previousUpdateTime = Date.now();
        requestFrame(update);
    }

    // Leave the replay for good. Guarded so the single onReplayOver fires once even
    // though the unmount cleanup also calls stop().
    function stop() {
        if (!localGameState.active) {
            return;
        }
        localGameState.active = false;
        onReplayOver();
    }

    // Play again from the start (used by the button once the replay has ended).
    function restart() {
        localGameState.replayTime = 0;
        localGameState.ended = false;
        localGameState.paused = false;
        localGameState.previousUpdateTime = Date.now();
    }

    function getReplayTime() {
        return localGameState.replayTime;
    }

    function setReplayProgress(progress) {
        localGameState.replayTime = progress * gameState.gameTime;
        // Scrubbing back from the end re-arms playback; scrubbing to the very end ends it.
        localGameState.ended = localGameState.replayTime >= gameState.gameTime;
    }

    function setSpeed(speed) {
        localGameState.speed = speed > 0 ? speed : 1;
    }

    function getSpeed() {
        return localGameState.speed;
    }

    function getReplayProgress() {
        return Math.min(localGameState.replayTime / gameState.gameTime, 1);
    }

    function pause() {
        localGameState.paused = true;
    }

    function resume() {
        localGameState.paused = false;
        localGameState.previousUpdateTime = Date.now();
    }

    function isPaused() {
        return localGameState.paused;
    }

    function isEnded() {
        return localGameState.ended;
    }

    function isReplayOver() {
        return !localGameState.active;
    }

    return {
        gameState,
        getReplayTime,
        start,
        stop,
        restart,
        setReplayProgress,
        getReplayProgress,
        setSpeed,
        getSpeed,
        pause,
        resume,
        isPaused,
        isEnded,
        isReplayOver
    };
};
